module.exports = __webpack_public_path__ + "static/media/facebook.ea5494c8.svg";